<template>
  <div class="wrapper footer-wrapper border-top pt-5" v-if="user">
    <div class="container py-5">
      <footer class="row row-cols-1 row-cols-sm-2 row-cols-md-4 pt-5">
        <div class="col mb-3">
          <a href="/" class="d-flex align-items-center mb-3 link-dark text-decoration-none">
            <img class="rounded-circle" src="https://zabugorshiki.com/wp-content/themes/understrap-child/images/logo_xs.jpg" width="50" height="50" alt="">
          </a>
          <p>
            <a class="text-dark" href="https://zabugorshiki.com/"><strong>ЗАБУГОРЩИКИ</strong></a><br>
            <small class="d-block mb-3">© 2023 В поисках лучшего.</small>
          </p>
        </div>

        <div class="col mb-3">
          <aside id="nav_menu-6" class="widget widget_nav_menu"><h3 class="widget-title">Походы</h3><div class="menu-pohody-container"><ul id="menu-pohody" class="menu"><li id="menu-item-3323" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-3323"><a href="https://zabugorshiki.com/hiking/">Все походы</a></li>
        <li id="menu-item-3325" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3325"><a href="https://travel.zabugorshiki.com">GPS-треки</a></li>
        <li id="menu-item-3335" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3335"><a href="https://zabugorshiki.com/tag/ile-alatau/">Заилийский Алатау</a></li>
        <li id="menu-item-3327" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3327"><a href="https://zabugorshiki.com/tag/medeo/">Медео</a></li>
        <li id="menu-item-3324" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3324"><a href="https://zabugorshiki.com/tag/shymbulak/">Чимбулак</a></li>
        </ul></div></aside>			</div>

              <div class="col mb-3">
                <aside id="nav_menu-2" class="widget widget_nav_menu"><h3 class="widget-title">Рубрики</h3><div class="menu-rubriki-container"><ul id="menu-rubriki" class="menu"><li id="menu-item-3322" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-3322"><a href="https://zabugorshiki.com/travel/">Путешествия</a></li>
        <li id="menu-item-3340" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-3340"><a href="https://zabugorshiki.com/sport/">Спорт</a></li>
        </ul></div></aside>			</div>

              <div class="col mb-3">
                <aside id="nav_menu-7" class="widget widget_nav_menu"><h3 class="widget-title">О нас</h3><div class="menu-o-nas-container"><ul id="menu-o-nas" class="menu"><li id="menu-item-3345" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-3345"><a href="https://zabugorshiki.com/about/">О нас</a></li>
        <li id="menu-item-3326" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-3326"><a href="https://zabugorshiki.com/podcast/">Подкаст</a></li>
        </ul></div></aside>			</div>
      </footer>
    </div>
  </div><!-- wrapper end -->
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'app-footer',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  created () {
  }
}
</script>